import createIconsObj from 'common/src/assets/icons/utils/createIconsObj';

const icons = createIconsObj(
  {
    topPerforming: '/mask-icon-insights.svg',
    impressionsOverTime: '/mask-icon-impressions-over-time-v2.svg',
    campaignKPIs: '/mask-icon-campaign-kpis-v2.svg',
    supportedDimensions: '/mask-icon-supported-dimensions.svg',
  },
  'copilot/campaign_analytics_agent',
);

export default icons;
